import { Box, Typography } from '@mui/material';
import rendezvousLogo from './Assets/rendezvousLogo.png';

const ThankYou = () => {
  return (
    <Box
      sx={{
        mt: 2,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 2,
        textAlign: 'center',
        px: 2,
      }}
    >
      <Box sx={{ display: 'flex', maxWidth: '90%', width: '500px', justifyContent: 'center' }}>
        <img
          src={rendezvousLogo}
          alt='Rendezvous Logo'
          style={{ maxWidth: '100%', height: 'auto' }}
        />
      </Box>
      <Typography variant='h4' component='h1' sx={{ color: '#222', mt: 2, fontWeight: 'bold' }}>
        Thank You for Making Rendezvous on the Red Unforgettable
      </Typography>
      <Typography variant='body1' sx={{ color: '#222', mt: 2, maxWidth: '800px' }}>
        As the curtain closes for Rendezvous on the Red, we want to thank you—from the bottom of our
        hearts—for being a part of something truly special. Whether you traveled far, made new
        connections, scored incredible deals on the products you love, or just came for a good time,
        you made this event shine.
        <br />
        <br />
        This site will be going quiet for now, but the memories, laughter, and energy we shared will
        echo on.
        <br />
        <br />
        Until next time—stay inspired, stay connected, and thank you for being part of the
        Rendezvous on the Red family.
      </Typography>
    </Box>
  );
};

export default ThankYou;
